import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-[#16231A] py-12" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img
                src="https://static.prod-images.emergentagent.com/jobs/d8a36d0e-acf5-4772-b845-b74bc2191557/images/0a9bc1777adf6f3c4201784effdb03c09d13cbe1b10ecbb42fe5c5571c07a9f7.png"
                alt="Food Safety Partners Logo"
                className="w-14 h-14 object-contain"
              />
              <div className="leading-tight">
                <span className="font-['Outfit'] font-bold text-white text-sm block">Food Safety</span>
                <span className="text-[10px] text-[#8BA18F] tracking-wider uppercase">Partners</span>
              </div>
            </div>
            <p className="text-sm text-[#8BA18F] leading-relaxed max-w-xs">
              Professional food safety audits, hygiene inspections and compliance support for modern food businesses.
            </p>
          </div>

          <div>
            <h4 className="font-['Outfit'] text-sm font-bold text-white mb-4">Quick Links</h4>
            <div className="space-y-2">
              {["About", "Services", "Why Us", "Process", "Contact"].map((l) => (
                <a key={l} href={`#${l.toLowerCase().replace(' ', '-')}`} className="block text-sm text-[#8BA18F] hover:text-[#7CA63A] transition-colors">
                  {l}
                </a>
              ))}
              <Link to="/free-checklists" className="block text-sm text-[#7CA63A] hover:text-[#8BC84A] transition-colors font-medium" data-testid="footer-checklists-link">
                Free Checklists
              </Link>
            </div>
          </div>

          <div>
            <h4 className="font-['Outfit'] text-sm font-bold text-white mb-4">Services</h4>
            <div className="space-y-2">
              {["Food Safety Audits", "Kitchen Hygiene Checks", "Compliance Support", "FSSAI License Support"].map((s) => (
                <span key={s} className="block text-sm text-[#8BA18F]">{s}</span>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-[#2D4233] pt-6 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-xs text-[#8BA18F]">
            &copy; {new Date().getFullYear()} Food Safety Partners. All rights reserved.
          </p>
          <p className="text-xs text-[#8BA18F]">
            info@foodsafetypartners.in
          </p>
        </div>
      </div>
    </footer>
  );
}
